// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import Label from '../../../components/Label';
import Iconify from '../../../components/Iconify';
import SvgIconStyle from '../../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;
const getIconify = (name) => <Iconify icon={`${name}`} />;

const ICONS = {
  portal: getIconify('simple-icons:codemagic'),
  money: getIconify('fa6-solid:money-check-dollar'),
  blog: getIconify('fluent:comment-16-filled'),
  tools: getIconify('fa-solid:tools'),
  guitar: getIconify('mdi:guitar-electric'),
  classicalguitar: getIconify('fa6-solid:guitar'),
  link: getIconify('fa-solid:link'),
  paste: getIconify('fa-solid:clipboard'),
  kanban: getIconify('bi:kanban-fill'),
  feedback: getIconify('eva:message-circle-fill'),
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    items: [
      { title: 'portal', path: PATH_DASHBOARD.general.app, icon: ICONS.portal },
      { title: 'Fretboard Visualiser', caption: 'Understand your guitar!', icon: ICONS.guitar, path: PATH_DASHBOARD.fretboard },
      // { title: 'Harmonic Minor', caption: 'Ascending and descending scale', icon: ICONS.guitar, path: PATH_DASHBOARD.harmonicMinor },
      { title: 'Segovia', caption: 'Scale exercise', icon: ICONS.classicalguitar, path: PATH_DASHBOARD.segovia },
      /* { title: 'ecommerce', path: PATH_DASHBOARD.general.ecommerce, icon: ICONS.ecommerce },
      { title: 'analytics', path: PATH_DASHBOARD.general.analytics, icon: ICONS.analytics },
      { title: 'banking', path: PATH_DASHBOARD.general.banking, icon: ICONS.banking },
      { title: 'booking', path: PATH_DASHBOARD.general.booking, icon: ICONS.booking }, */
    ],
  },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  /* {
    subheader: 'management',
    items: [
      // USER
      {
        title: 'user',
        path: PATH_DASHBOARD.user.root,
        icon: ICONS.user,
        children: [
          { title: 'profile', path: PATH_DASHBOARD.user.profile },
          { title: 'cards', path: PATH_DASHBOARD.user.cards },
          { title: 'list', path: PATH_DASHBOARD.user.list },
          { title: 'create', path: PATH_DASHBOARD.user.new },
          { title: 'edit', path: PATH_DASHBOARD.user.demoEdit },
          { title: 'account', path: PATH_DASHBOARD.user.account },
        ],
      },

      // E-COMMERCE
      {
        title: 'ecommerce',
        path: PATH_DASHBOARD.eCommerce.root,
        icon: ICONS.cart,
        children: [
          { title: 'shop', path: PATH_DASHBOARD.eCommerce.shop },
          { title: 'product', path: PATH_DASHBOARD.eCommerce.demoView },
          { title: 'list', path: PATH_DASHBOARD.eCommerce.list },
          { title: 'create', path: PATH_DASHBOARD.eCommerce.new },
          { title: 'edit', path: PATH_DASHBOARD.eCommerce.demoEdit },
          { title: 'checkout', path: PATH_DASHBOARD.eCommerce.checkout },
        ],
      },

      // INVOICE
      {
        title: 'invoice',
        path: PATH_DASHBOARD.invoice.root,
        icon: ICONS.invoice,
        children: [
          { title: 'list', path: PATH_DASHBOARD.invoice.list },
          { title: 'details', path: PATH_DASHBOARD.invoice.demoView },
          { title: 'create', path: PATH_DASHBOARD.invoice.new },
          { title: 'edit', path: PATH_DASHBOARD.invoice.demoEdit },
        ],
      },

      // BLOG
      {
        title: 'blog',
        path: PATH_DASHBOARD.blog.root,
        icon: ICONS.blog,
        children: [
          { title: 'posts', path: PATH_DASHBOARD.blog.posts },
          { title: 'post', path: PATH_DASHBOARD.blog.demoView },
          { title: 'create', path: PATH_DASHBOARD.blog.new },
        ],
      },
    ],
  },

  // APP
  // ----------------------------------------------------------------------
  {
    subheader: 'app',
    items: [
      {
        title: 'mail',
        path: PATH_DASHBOARD.mail.root,
        icon: ICONS.mail,
        info: <Label color="error">+32</Label>,
      },
      { title: 'chat', path: PATH_DASHBOARD.chat.root, icon: ICONS.chat },
      { title: 'calendar', path: PATH_DASHBOARD.calendar, icon: ICONS.calendar },
      { title: 'kanban', path: PATH_DASHBOARD.kanban, icon: ICONS.kanban },
    ],
  }, */

  // DEMO MENU STATES
  {
    subheader: 'Administrator',
    perms: ['admin', 'readfeedback'],
    items: [
      {
        title: 'Site Settings',
        icon: ICONS.tools,
        path: PATH_DASHBOARD.tools.root,
        perms: ['admin'],
        children: [
          {
            title: 'Invite Codes',
            path: PATH_DASHBOARD.admin.inviteCodes,
            icon: ICONS.link,
            caption: 'Manage registrations',
            perms: ['admin'],
          },
          {
            title: 'Feature Teasers',
            path: PATH_DASHBOARD.admin.featureTeasers,
            icon: ICONS.portal,
            caption: 'Manage teaser cards',
            perms: ['admin'],
          },
          { title: 'Redirects', caption: 'Shortened links', icon: ICONS.link, path: PATH_DASHBOARD.admin.shortlinks },
          { title: 'Pastes', caption: 'Paste bin', icon: ICONS.paste, path: PATH_DASHBOARD.admin.pastes },
          // { title: 'Kanban', icon: ICONS.kanban, path: PATH_DASHBOARD.tools.kanban },
        ],
      },
      {
        title: 'Feedback Inbox',
        path: PATH_DASHBOARD.admin.feedback,
        icon: ICONS.feedback,
        caption: 'Review user feedback',
        perms: ['admin', 'readfeedback'],
      },
      /* {
        title: 'menu_level_1',
        path: '#1',
        icon: ICONS.menuItem,
        children: [
          { title: 'menu_level_2', path: '#2', disabled: true },
          {
            title: 'menu_level_2',
            path: '#3',
            children: [
              { title: 'menu_level_3', path: '#4' },
              { title: 'menu_level_3', path: '#5' },
            ],
          },
        ],
      },
      { title: 'item_disabled', path: '#disabled', icon: ICONS.menuItem, disabled: true },
      {
        title: 'item_label',
        path: '#label',
        icon: ICONS.menuItem,
        info: (
          <Label color="info" startIcon={<Iconify icon="eva:email-fill" />}>
            NEW
          </Label>
        ),
      },
      { title: 'item_caption', path: '#caption', icon: ICONS.menuItem, caption: 'description' }, */
    ],
  },
];

export default navConfig;
